import { apiClient } from "helpers/api_helper";


export const GetInterStoreOderList = async (data : any) => {
    try {
        const response = await apiClient.get('/api/v1/InterStoreTransfer/GetInterStoreOderList',data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};